$(document).ready(function(){

	// -- read-more --
	$('.btn--readmore').on('click', function(){
		$(this).parents('article').toggleClass('readmore--open');
		$(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
	});

});